import { faFlagSwallowtail as faFlagSwallowtailRegular } from '@fortawesome/pro-regular-svg-icons';
import { faFlagSwallowtail as faFlagSwallowtailSolid } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useDispatch, useSelector } from '@redux';
import { createOrderBatches } from '@redux/orderBatches/actions';
import { Button, notification } from 'antd';
import { DynamicObjectType } from 'core/types/common';
import React from 'react';

interface IPriorityBatchButtonProps {
  record?: any;
  data?: any;
  model?: string;
}

const PriorityBatchButton = ({ record, model }: IPriorityBatchButtonProps) => {
  const dispatch = useDispatch();

  const _record = useSelector<DynamicObjectType>(
    (state) => state[model]?.data[record?.id],
  );
  const [loading, setLoading] = React.useState(false);

  const handleClick = async () => {
    try {
      if (!_record?.isPriority) {
        setLoading(true);
        const { payload } = await dispatch(
          createOrderBatches({
            data: {},
            options: {
              customApiResource: 'order-batches',
              suffix: `/${record?.id}/mark-priority`,
            },
          }),
        );
        await setLoading(false);
        if ((payload as any)?.data?.success) {
          window.location.reload();
        } else {
          notification.error({
            message: 'Error',
            description: 'Failed to prioritize batch',
          });
        }
      }
    } catch {
      setLoading(false);
    }
  };

  return (
    <Button
      icon={
        !_record?.isPriority ? (
          <FontAwesomeIcon icon={faFlagSwallowtailRegular} />
        ) : (
          <FontAwesomeIcon
            icon={faFlagSwallowtailSolid}
            className="text-red-500"
          />
        )
      }
      onClick={handleClick}
      loading={loading}
    >
      {_record?.isPriority ? 'Prioritized' : ''}
    </Button>
  );
};

export default PriorityBatchButton;
